export const PRODUCT_REQUEST_LIMIT = 20

export const LOCAL_STORAGE_TUTORIAL_DISABLED = 'stockLibrary_tutorial_disabled'

export const LOCAL_STORAGE_CROSS_SELL_MODAL_DISABLED = 'stockLibrary_cross_sell_modal_disabled'
